import { useAtomValue } from 'jotai';
import brokenImageUrlsAtom from './brokenImageUrlsAtom';
const useBrokenImageUrls = () => {
  const brokenImageUrls = useAtomValue(brokenImageUrlsAtom);
  return brokenImageUrls;
};
export default useBrokenImageUrls;